<app-content-container>
  <div class="max-w-3xl mx-auto text-center">
    <h1 class="section-title">
      Mentoria <span class="angular-font-color">exclusiva</span> para alunos
    </h1>
    <p class="section-description mt-6">
      Todo mês a nossa comunidade escolhe o tema da próxima mentoria. Nos
      encontramos ao vivo para compartilhar conhecimento e resolver as suas
      dúvidas em tempo real.
    </p>
  </div>
</app-content-container>
